import { createI18n, I18nOptions } from 'vue-i18n'
import { Currency } from '@workspace/sab-core'

export default async function i18n (currency: Currency, locale = 'en-US') {
  const numberFormats: I18nOptions['numberFormats'] = {
    [locale]: {
      currency: {
        currency,
        style: 'currency',
        notation: 'standard',
        maximumFractionDigits: 0
      }
    }
  }

  /* Import corresponding files */
  const [commonTranslations, templateTranslations] = await Promise.all([
    import(`@workspace/template-commons/translations/${locale}.json`),
    import(`./${locale}.json`)
  ])

  return createI18n({
    legacy: false,
    locale,
    messages: {
      [locale]: Object.assign({}, commonTranslations, templateTranslations)
    },
    numberFormats
  })
}
